import React from 'react'

const NotFound = () => {
    return (
        <div className="flex items-center justify-center h-screen">
            <h1 className="text-4xl font-bold">404 Not Found</h1>
        </div>
    )
}

export default NotFound